const appraise = {
    saleScoreInfoSave: '/saleScoreInfo/save',
    saleScoreInfoPage: '/saleScoreInfo/page',
    saleScoreInfoSelectAppeal: '/saleScoreInfo/selectAppeal',
    saleScoreInfoSelectAppealGrade: '/saleScoreInfo/selectAppealGrade',
    funcGradeDetail: '/func/grade/detail',
    funcGradeSave: '/func/grade/save',
    funcGradeConfirm: '/func/grade/confirm',
    funcGradeAppeal: '/func/grade/appeal',
    funcGradeAppeal2: '/func/grade/appeal2',
    flowInfoQueryFlowApproveNotice:'/flowInfo/queryFlowApproveNotice',
    saleScoreInfoSelectNodeGrade: '/saleScoreInfo/selectNodeGrade',
    saleScoreInfoQueryIndexGoal: '/saleScoreInfo/queryIndexGoal',
    saleScoreInfoSaveOneGrade: '/saleScoreInfo/saveOneGrade', // 销售考核评分-保存
    saleScoreInfoSubmitOneGrade: '/saleScoreInfo/submitOneGrade', // 销售考核评分-提交
    saleScoreInfoSubmitGrade: '/saleScoreInfo/submitGrade', //销售/市场类（考核）提交
    saleObjectManagerInfoAssessType: '/sale_object_manager_info/assessType',
    saleScoreInfoGetSaleGradeStates: '/saleScoreInfo/getSaleGradeStates',
    saleScoreInfoGetSaleAppealStates : '/saleScoreInfo/getSaleAppealStates',
    saleScoreInfoGetSalePeriodStates: '/saleScoreInfo/getSalePeriodStates',
    saleScoreInfoAffirm: '/saleScoreInfo/affirm',
    saleScoreInfoQueryGrade: '/saleScoreInfo/queryGrade',
    saleScoreInfoAppealGradeLaunch: '/saleScoreInfo/appealGradeLaunch',
    saleScoreInfoQueryGradeHistoricalDocuments:'/saleScoreInfo/queryGradeHistoricalDocuments',
    saleScoreInfoSelectHistoricalDocuments: '/saleScoreInfo/selectHistoricalDocuments',
    saleScoreInfoSelectHistorical: '/saleScoreInfo/selectHistorical',
    saleScoreInfoQueryApprovalOpinion: '/saleScoreInfo/queryApprovalOpinion',
    funcGradeQueryHistoryGrade: '/func/grade/queryHistoryGrade',
    funcGradeQueryDeptObject: '/func/grade/queryDeptObject',
    funcGradeCalculate: '/func/grade/calculate',
    execFlowScoreInfoPage: '/ExecFlowScoreInfo/page', // 高管考核-列表查询
    execFlowScoreInfo: '/ExecFlowScoreInfo/info', // 高管考核-评分详情
    execFlowScoreInfoBatchSubmit: '/ExecFlowScoreInfo/batchSubmit', // 高管考核-批量提交

    saleScoreInfoSubmitGrade1: '/saleScoreInfo/submitGradeBatch', //销售/市场类（考核）四期提交
    batchCalculationOfSTI:'/saleScoreInfo/salesStiAchievingRateBatch',//批量计算sti达成率
    
}

export default appraise;